// extracted by mini-css-extract-plugin
export default {"files":"reportsPage_files__Cbbe4","file":"reportsPage_file__KZF0-","file_name":"reportsPage_file_name__+BOaX","file_format":"reportsPage_file_format__398+I"};